import React from 'react';

const CONTACT = {
  email: 'saad.beidouri.pro@gmail.com',
  github: 'https://github.com/SaadBeidourii',
  linkedin: 'https://www.linkedin.com/in/saad-beidouri-23b6481b4/',
  linkedinLabel: 'linkedin.com/in/saad-beidouri',
};

const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <polyline points="2 8 12 13 22 8" />
  </svg>
);

const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
  </svg>
);

const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const ChevronRight = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="5 3 9 7 5 11" />
  </svg>
);

const LINKS = [
  {
    label: 'Email',
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
    Icon: EmailIcon,
  },
  {
    label: 'GitHub',
    value: 'github.com/SaadBeidourii',
    href: CONTACT.github,
    Icon: GithubIcon,
    external: true,
  },
  {
    label: 'LinkedIn',
    value: CONTACT.linkedinLabel,
    href: CONTACT.linkedin,
    Icon: LinkedInIcon,
    external: true,
  },
];

const Contact = () => (
  <section id="contact" className="section contact-section">
    <div className="container">
      <p className="section-label">Get in touch</p>
      <h2 className="section-title">Contact</h2>

      <div className="contact-inner">
        <div className="contact-links">
          {LINKS.map(({ label, value, href, Icon, external }) => (
            <a
              key={label}
              href={href}
              className="contact-link-row"
              {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              <div className="contact-link-icon">
                <Icon />
              </div>
              <div className="contact-link-meta">
                <span className="contact-link-label">{label}</span>
                <span className="contact-link-value">{value}</span>
              </div>
              <span className="contact-link-arrow">
                <ChevronRight />
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
